/** Public marketing routes. An auth failure here must not replace the page with Sign In. */

const PUBLIC_PATHS = new Set([
  "/",
  "/pricing",
  "/privacy",
  "/changelog",
  "/terms_of_service",
  "/legal/terms-of-service",
  "/account-deletion",
  "/signin",
  "/signup",
  "/password_reset",
  "/password_reset_confirmation",
  "/set_password",
]);

export function normalizeAppPath(pathname: string | null | undefined): string {
  if (!pathname || pathname === "/") return "/";
  return pathname.endsWith("/") ? pathname.slice(0, -1) : pathname;
}

export function isPublicApiRequest(requestUrl: string | null | undefined): boolean {
  return String(requestUrl || "").includes("/public/");
}

export function isPublicAppPath(pathname: string | null | undefined): boolean {
  return PUBLIC_PATHS.has(normalizeAppPath(pathname));
}

export function shouldRedirectToSignIn(
  requestUrl: string | null | undefined,
  pathname: string | null | undefined,
): boolean {
  if (isPublicApiRequest(requestUrl)) return false;
  if (isPublicAppPath(pathname)) return false;
  return true;
}
